import React from "react";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import StatusCard from "./StatusCard";

const PickWebsite: React.FC = () => (
    <StatusCard
        accentColor="var(--st-accent)"
        icon={faGlobe}
        title="Vyberte stránku"
        text="Na ľavej strane prosím vyberte jednu z možných stránok."
        minHeight="82vh"
    />
);

export default PickWebsite;
